'use strict';

function CompanyCustomersService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/customers/:customerId', {}, {
    'update': {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    },
    'queryFiles': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/customers/:customerId/files',
      isArray: true
    },
    'uploadFiles': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/customers/:customerId/files'
    },
    'deleteFile': {
      method: 'DELETE',
      url: config.apiBase + '/companies/:companyId/customers/:customerId/files/:fileId'
    },
    'fileToken': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/customers/:customerId/files/:fileId/tokens'
    },
    'queryAddresses': {
      url: config.apiBase + '/companies/:companyId/customers/:customerId/address',
      method: 'GET',
      isArray: true
    },
    'updateAddress': {
      url: config.apiBase + '/companies/:companyId/customers/:customerId/address/:addressId',
      method: 'POST'
    },
    'deleteAddress': {
      url: config.apiBase + '/companies/:companyId/customers/:customerId/address/:addressId',
      method: 'DELETE'
    },
    'addObject': {
      url: config.apiBase + '/companies/:companyId/customers/:customerId/objects',
      method: 'POST'
    },
    'removeObject': {
      url: config.apiBase + '/companies/:companyId/customers/:customerId/objects/:objectId',
      method: 'DELETE'
    },
    'queryUnits': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/customers/:customerId/units',
      isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyCustomersService', ['$resource', 'config', CompanyCustomersService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customers/CompanyCustomersService.js
// module id = 16
// module chunks = 0